import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "onyxlife_collection_badge";
const SYNC_EVENT = "collectionBadgeChange";

/**
 * Tracks unseen collection additions via localStorage.
 * Increment when a media note is created, clear when Collection page is visited.
 * Uses a custom DOM event to sync across components within the same tab.
 */
export default function useCollectionBadge() {
  const [count, setCount] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) || 0 : 0;
  });

  // Sync across components within the same tab via custom event
  useEffect(() => {
    const onSync = () => {
      const stored = localStorage.getItem(STORAGE_KEY);
      setCount(stored ? parseInt(stored, 10) || 0 : 0);
    };
    window.addEventListener(SYNC_EVENT, onSync);
    return () => window.removeEventListener(SYNC_EVENT, onSync);
  }, []);

  const increment = useCallback(() => {
    setCount((prev) => {
      const next = prev + 1;
      localStorage.setItem(STORAGE_KEY, String(next));
      window.dispatchEvent(new Event(SYNC_EVENT));
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    setCount(0);
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(SYNC_EVENT));
  }, []);

  return { count, increment, clear };
}
